import React, { useState } from 'react';
import { Button } from "react-bootstrap";
import AddOfferModel from "features/offers/addOfferModel";
import AddOfferModal from 'features/offers/AddOfferModal';
import { OfferTypeEnum } from "domain/offerType";
import usePermission from 'common/security/usePermission';
import Permissions from "common/security/permissions";

interface AddOfferButtonProps {
    text?: string;
}

const AddOfferButton: React.FC<AddOfferButtonProps> = (props: AddOfferButtonProps) => {
    const [isAddOfferModalVisible, showAddOfferModal] = useState(false);
    const [addOfferModel, setAddOfferModel] = useState<AddOfferModel>(null);
    const isPushBasisEnabled = usePermission(Permissions.PushBasis);

    function addOffer() {
        const model: AddOfferModel = {
             customerWillSell: true,
             offerType: OfferTypeEnum.Cash,
        };
        setAddOfferModel(model);
        showAddOfferModal(true);
    }

    function onClose() {
        showAddOfferModal(false);
        setAddOfferModel(null);
    }

    return (isPushBasisEnabled &&
        <div>
            <Button onClick={addOffer} variant="link" className="text-decoration-none">
                <i className="material-icons">add_circle_outline</i> {props.text ?? "Add Offer/Contract"}
            </Button>
            {isAddOfferModalVisible && <AddOfferModal 
                model={addOfferModel}
                onClose={onClose} />
            }
        </div>
        );
};

export default AddOfferButton;